import { render, staticRenderFns } from "./regulationsList.vue?vue&type=template&id=b826fa16&scoped=true&"
import script from "./regulationsList.vue?vue&type=script&lang=js&"
export * from "./regulationsList.vue?vue&type=script&lang=js&"
import style0 from "./regulationsList.vue?vue&type=style&index=0&id=b826fa16&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b826fa16",
  null
  
)

export default component.exports